import { render, staticRenderFns } from "./HomeSalesByCustomer.vue?vue&type=template&id=0f68106c&scoped=true&"
import script from "./HomeSalesByCustomer.vue?vue&type=script&lang=js&"
export * from "./HomeSalesByCustomer.vue?vue&type=script&lang=js&"
import style0 from "./HomeSalesByCustomer.vue?vue&type=style&index=0&id=0f68106c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68106c",
  null
  
)

export default component.exports